import { Component, OnInit } from '@angular/core';
import { UntypedFormGroup, Validators } from "@angular/forms";
import { FormService } from "../../services/form.service";

@Component( {
	selector: 'app-property-type-details-from',
	templateUrl: './property-type-details-from.component.html',
	styleUrls: ['./property-type-details-from.component.scss']
} )
export class PropertyTypeDetailsFromComponent implements OnInit {

	propertyTypeDetailsFrom !: UntypedFormGroup
	formGroupName: string = 'propertyTypeDetailsFrom'
	elevatorEnabled = false;
	floorLevels: any;

	constructor(public formService: FormService) {
	}

	ngOnInit(): void {

		this.propertyTypeDetailsFrom = this.formService.mainForm.get( this.formGroupName ) as UntypedFormGroup;
		this.floorLevels = this.formService.getFloorLevels();
	}

	onSubmit() {

		this.formService.submitFormGroup( (<UntypedFormGroup>this.propertyTypeDetailsFrom) );
	}

	onFloorChange( $event: any ) {

		// If more floors than 0
		if( $event.value > 1 ) {

			// Show elevator field and make it required
			this.elevatorEnabled = true;

			(<UntypedFormGroup>this.propertyTypeDetailsFrom).controls['elevator'].addValidators( Validators.required );
		}
		else {

			// Hide elevator and make it un-required
			this.elevatorEnabled = false;

			(<UntypedFormGroup>this.propertyTypeDetailsFrom).controls['elevator'].removeValidators( Validators.required );
			(<UntypedFormGroup>this.propertyTypeDetailsFrom).controls['elevator'].reset();
		}
	}

	onElevatorChange() {

		// Small timeout for user experience
		setTimeout( () => {

			this.onSubmit();
		}, 200 );
	}
}
